import React, { useState, useEffect } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import ReactPlayer from "react-player";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getDistributorCornerMFD } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getRouting, getYoutubePosterImage, checkIframeContent} from "../../../../../utils/common";


const BeingaMFD = (props) => {
  const {
    getDistributorCornerMFD,
    distributorCornerWhyBe,
    distributorGetStarted,
    distributorBecomeData,
    location: { pathname },
  } = props;


  const getCurrent = (nc) => {
    switch (nc) {
      case "why-become-mfd":
        return 0;
      case "get-started":
        return 1;
      case "become-an-distributor":
        return 2;
      default:
        return 0;
    }
  };

  const current = pathname.split("/")[3];
  const [currentPageurl, setCurrentPageurl] = useState("why-become-mfd");
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [defaultVideoId, setdefaultVideoId] = useState([]);
  const [metaData, setMetaData] = useState();
  const [flag , setFlag] = useState(false);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  useEffect(() => {
    if (current) {
      setCurrentPageurl(current);
    }
  }, [current]);

  useEffect(() => {
    if (currentPageurl === "why-become-mfd") {
      setSelectedIndexTab(0);
    }
    if (currentPageurl === "get-started") {
      setSelectedIndexTab(1);

    }
    if (currentPageurl === "become-an-distributor") {
      setSelectedIndexTab(2);

    }
  }, [currentPageurl]);

  useEffect(() => {
    if (current === "why-become-mfd") {
      !(distributorCornerWhyBe && distributorCornerWhyBe.data && distributorCornerWhyBe.data.body && flag == false) && getDistributorCornerMFD({},"why-be-a-mfd-distributor");
    }
    if (current === "get-started") {
      !(distributorGetStarted && distributorGetStarted.data && distributorGetStarted.data.body && distributorGetStarted.data.nav && flag == false) &&getDistributorCornerMFD({},"get-started");
    }
    if (current === "become-an-distributor") {
      !(distributorBecomeData && distributorBecomeData.data && distributorBecomeData.data.body && flag == false) && getDistributorCornerMFD({},"become-an-distributor");
    }
  }, [current]);


  useEffect(() => {
    if (distributorCornerWhyBe && distributorCornerWhyBe.data && distributorCornerWhyBe.data.videos) {
      setdefaultVideoId(distributorCornerWhyBe.data.videos[0])
    }
  }, [distributorCornerWhyBe]);


  useEffect(() => {
    if (currentPageurl === "why-become-mfd" &&
      distributorCornerWhyBe && distributorCornerWhyBe.meta
    ) {
      setMetaData(distributorCornerWhyBe.meta)
    }
    if (currentPageurl === "get-started" &&
      distributorGetStarted && distributorGetStarted.meta
    ) {
      setMetaData(distributorGetStarted.meta)
    }
    if (currentPageurl === "become-an-distributor" &&
      distributorBecomeData && distributorBecomeData.meta) {
      setMetaData(distributorBecomeData.meta)
    }
  }, [currentPageurl, distributorCornerWhyBe, distributorGetStarted, distributorBecomeData]);

  const handleChangeVideo = async (e, item) => {
    setdefaultVideoId(item)
  };

  const handleApiCall = (e, tabName) => {
    setMetaData('');
    setCurrentPageurl(tabName);
    setFlag(true);
  };

  return (
    <div className={checkIframeContent() ? "wrapper":""}>

      {metaData && metaData != null ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta
            name="keywords"
            content={metaData && metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData && metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta
            property="og:image"
            content={metaData && metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData && metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      ) : (
        ""
      )}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              <span>Being a </span> MFD
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                {checkIframeContent() && <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>}
                <li className="breadcrumb-item">
                  {checkIframeContent() ? <a href="/distributor-corner">Distributer Corner</a>:<Link to={getRouting("/distributor-corner")}>Distributer Corner</Link>}
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  Being a MFD
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <Tabs className="customTab" selectedIndex={selectedIndexTab}>
            <TabList>
              <Link to={getRouting("/distributor-corner/being-a-mfd/why-become-mfd", "why-become-mfd")}>
                <Tab
                  onClick={async (e) => await handleApiCall(e, "why-become-mfd")}
                  tabFor="0"
                  value={0}>
                  <div>
                    <h2 className="tabhead">Why become MFD*</h2>
                  </div>
                </Tab>
              </Link>

              <Link to={getRouting("/distributor-corner/being-a-mfd/get-started", "get-started")}>
                <Tab
                  onClick={async (e) => await handleApiCall(e, "get-started")}
                  tabFor="1"
                  value={1}
                >
                  <div>
                    <h2 className="tabhead">Get Started</h2>
                  </div>
                </Tab>
              </Link>

              <Link to={getRouting("/distributor-corner/being-a-mfd/become-an-distributor", "become-an-distributor")}>
                <Tab
                  onClick={async (e) => await handleApiCall(e, "become-an-distributor")}
                  tabFor="2"
                  value={2}
                >
                  <div>
                    <h2 className="tabhead">Become a HDFC MFD</h2>
                  </div>
                </Tab>
              </Link>

            </TabList>
            <TabPanel>
              <div>
                <div className="row beingmfd">
                  <div className="col-md-6 p-0">
                    <h2 className="mfdtitle">
                      {distributorCornerWhyBe &&
                        distributorCornerWhyBe.data &&
                        distributorCornerWhyBe.data.title &&
                        distributorCornerWhyBe.data.title
                      }

                    </h2>
                    {
                      distributorCornerWhyBe &&
                        distributorCornerWhyBe.data &&
                        distributorCornerWhyBe.data.body ?
                        <div dangerouslySetInnerHTML={{ __html: distributorCornerWhyBe.data.body }} /> : ''
                    }
                  </div>
                  <div className="col-md-6  p-0">
                    <img
                      src="/images/New/DistributorCorner/mfddistributor.svg"
                      alt="distributorscorner"
                      className="img-fluid"
                    />
                    {/* <svg width="524" height="314" viewBox="0 0 524 314" fill="none" xmlns="http://www.w3.org/2000/svg"  xmlnsXlink="http://www.w3.org/1999/xlink">
                      <rect width="524" height="314" fill="url(#pattern0)" />
                      <defs>
                        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlinkHref="#image0_1_763" transform="matrix(0.00126582 0 0 0.00211239 0 -0.000636943)" />
                        </pattern>
                      </defs>
                    </svg> */}

                  </div>
                </div>
                {
                  distributorCornerWhyBe &&
                  distributorCornerWhyBe.data &&
                  distributorCornerWhyBe.data.videos &&
                  distributorCornerWhyBe.data.videos ?
                  <h2 className="titles mt-5">
                  Videos
                </h2> : ""
                }
                

                <div className="row mb-5">
                  {defaultVideoId && defaultVideoId.youtubeId ?
                    <div className="col-md-7 videosec mb-4">
                      <ReactPlayer
                        // url="https://www.youtube.com/watch?v=bMknfKXIFA8"
                        url={defaultVideoId ? `https://www.youtube.com/watch?v=${defaultVideoId.youtubeId}` : ''}
                        controls={true}
                        className="videoplayer"
                        muted={true}
                        playing={true}
                      />
                      <div className="defaultVideoDetails">
                        <h2>
                          {defaultVideoId.youtubeTitle
                            ? defaultVideoId.youtubeTitle
                            : ""}
                        </h2>
                        <p className="">{defaultVideoId.description ? defaultVideoId.description : ""}
                        </p>
                      </div>
                    </div> : ""
                  }
                  
                  {
                    distributorCornerWhyBe &&
                    distributorCornerWhyBe.data &&
                    distributorCornerWhyBe.data.videos &&
                    distributorCornerWhyBe.data.videos ?
                  
                  <div className="col-md-5 videosecright mb-4">
                    {
                      distributorCornerWhyBe &&
                      distributorCornerWhyBe.data &&
                      distributorCornerWhyBe.data.videos &&
                      distributorCornerWhyBe.data.videos
                        .filter((item) => item.youtubeId !== defaultVideoId.youtubeId)
                        .map((item, index) => {
                          let isYoutubeVideo = "youtubeId" in item;
                              const posterImage = isYoutubeVideo
                              ? getYoutubePosterImage(item.youtubeId)
                              : item;
                          return(
                            <div className="row mb-3">
                              <div className="col">
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) => handleChangeVideo(e, item)}
                                >
                                  <div className="mainvideo">
                                  {!posterImage ? (
                                    <img
                                      src="/images/New/learnNew/articlesimg.svg"
                                      className="w-100 webinarvideo"
                                      alt="MFD Distributor"
                                    />
                                  ) : (
                                    <img
                                      src={posterImage}
                                      className="w-100 imgh webinarvideo"
                                      alt={item.youtubeTitle ? item.youtubeTitle : ""}
                                    />
                                  )}
                                    <img
                                      src="/images/New/learnNew/you-tube-play-icon.png"
                                      className="playicon"
                                      alt="Play Icon"
                                    />

                                    <div className="readcls">{item.duration ? item.duration : ""}</div>
                                  </div>
                                </a>
                              </div>

                              <div className="col">
                                <a
                                  href="javascript:void(0)"
                                  className="leftVideoTitle"
                                >
                                  <h3>{item.youtubeTitle ? item.youtubeTitle : ""}</h3>
                                  <p className="">{item.description ? item.description : ""}</p>
                                </a>
                              </div>
                            </div>
                        )
                        })
                    }
                  </div> : ""
                  }
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div>
                <div className="beingmfd">
                  <h2 className="mfdtitle">{distributorGetStarted &&
                    distributorGetStarted.data &&
                    distributorGetStarted.data.title &&
                    distributorGetStarted.data.title
                  }</h2>

                  {
                    distributorGetStarted &&
                      distributorGetStarted.data &&
                      distributorGetStarted.data.body ?
                      <div dangerouslySetInnerHTML={{ __html: distributorGetStarted.data.body }} /> : ''
                  }

                  <div className="row mt-5">
                    {
                      distributorGetStarted &&
                      distributorGetStarted.data &&
                      distributorGetStarted.data.nav &&
                      distributorGetStarted.data.nav.map((item, index) => (
                        <div className="col-md-4 mb-4" key={index}>
                          <div className="getstartedcard">
                            <h3 className="startedtitle">{item.title}</h3>
                            <p>{item.description}</p>
                            <a href={item.link.uri} className="btn btn-primary w-100">
                              {item.link.title}
                            </a>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="distributclass">
                {
                  distributorBecomeData &&
                    distributorBecomeData.data &&
                    distributorBecomeData.data.body ?
                    <div dangerouslySetInnerHTML={{ __html: distributorBecomeData.data.body }} /> : ''
                }
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  distributorCornerWhyBe: state.DistributorCorner.distributorCornerWhyBe,
  distributorGetStarted: state.DistributorCorner.distributorGetStarted,
  distributorBecomeData: state.DistributorCorner.distributorBecomeData,
});

const mapDispatchToProps = (dispatch) => ({
  getDistributorCornerMFD: bindActionCreators(getDistributorCornerMFD, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BeingaMFD);
